<template>
  <div
    v-clickoutside="close"
    :class="['by-autocomplete', { autocomplete__open: popVisible }]"
  >
    <div :style="{}" :class="['input-container',{pickup__error:!popVisible}]">
      <!-- 前置内容 -->
      <span class="input__prefix">
        <slot name="prefix"> </slot>
      </span>
      <input
        ref="input"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        v-bind="[$props, $attrs]"
        class="by-input__inner"
      />
    </div>
  <transition name="el-zoom-in-top" >

    <div v-show="popVisible" class="by-autocomplete-suggestion">
      <div class="flex">
      <slot name="tabtype"></slot>
      <el-scrollbar
        tag="ul"
        wrap-class="el-autocomplete-suggestion__wrap"
        view-class="el-autocomplete-suggestion__list"
        height="78px"
      >
        <li
          @click="handleClick(item)"
          class="li-item"
          v-for="(item, index) in suggestion"
          :key="index"
        >
          <slot :item="item">
            {{ item['label'] }}
          </slot>
        </li>
        <li class="li-item li-nodata" v-if="suggestion.length === 0">
          <span>No Data</span>
          <span> </span>
        </li>
        <slot></slot>
      </el-scrollbar>
      </div>
    </div>
  </transition>

  </div>
</template>

<script>
 
    import Emitter from "@/utils/emitter";
export default {
  inheritAttrs: false,
  mixins: [Emitter],
  props: {
    fetchSuggestions: {
      type: Function,
    },
    valueKey: {
      type: String,
      default: "value",
    },
    labelKey: {
      type: String,
      default: "label",
    },
    value:{},
    tabType:{
      type:Boolean,
      default:()=>{
        return false
      }
    }
  },
  watch:{
    value(val){
      this.dispatch('ByFormItem', 'by.form.blur',[val]);
    }
  },
  data() {
    return {
      popVisible: false,
      suggestion: [],
      isColse:this.tabType,
    };
  },
  methods: {
    focus(){
      setTimeout(()=>{
          this.$refs['input'].focus()
      },0)
     
    },
    handleFocus(e) {
      this.popVisible = true;
      this.getData('');
      this.$emit("focus");
    },
    handleBlur() {
      
      // setTimeout(()=>{
      //   // debugger
      //   console.log("🚀 ~ this.value", this.value)
      //   this.dispatch('ByFormItem', 'by.form.blur',[this.value]);
      // },150)
      
      if (this.suggestion.length === 0) {
        this.$emit("input", "");
        return;
      }
    },
    handleInput(e) {
      this.$emit("input", e.target.value);
      this.getData(e.target.value);
    },
    handleClick(item) {
      this.$emit('select',item)
      this.$emit("input", item[this.labelKey]);
      // debugger
      this.close();
    },
    //关闭弹框
    close() {
      if(this.isColse){
        this.handleFocus();
      }else{
        this.popVisible = false;
      }
        
    },
    //筛选数据
    getData(queryString) {
      this.fetchSuggestions(queryString, (res) => {
        this.suggestion = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped >

.by-autocomplete {
  height: 60px;
  box-sizing: border-box;
  // background-color: #577ec7;
    // border-radius: 30px;

  .input-container {
    font-size: 15px;
    position: relative;
    height: 100%;
    border-radius: 30px;
    padding: 0 20px;
    background-color: #577ec7;
    display: flex;
    overflow: hidden;
    transition: all .3s;
    .input__prefix {
      color: #fff;
      // height:100%;
      text-align: center;
      line-height: 60px;
      & > * {
        margin-right: 10px;
      }
    }
  }
  .by-input__inner {
    // border-radius: 10px;//input 宽 过大
    height: 100%;
    background-color: #577ec7;
    border: none;
    box-sizing: border-box;
    color: #fff;
    display: inline-block;
    font-size: inherit;
    line-height: 100%;
    outline: none;
    flex: 1;
    &:focus {
      // border-color: red !important;
      outline: none !important;
    }
    @include inputPlaceholder(#abbee3)

  }
}

.by-autocomplete {
  & /deep/ .el-autocomplete-suggestion__wrap {
    max-height: 400px;
    padding: 0;
  }

  & /deep/ .el-autocomplete-suggestion__list{
    background-color: #577ec7;
    // padding: 0 20px;
  }
  .li-item {
    height: 39px;
    color: #ffffff;
    font-size: 14px;
    line-height: 39px;
    padding: 0 20px;
    &:hover {
      background: #89a4d7;
    }
  }
  .li-nodata {
    text-align: center;
    line-height: 78px;
    height: 78px;
  }
}

// 弹框打开时
.autocomplete__open {
  position: relative;
  // &.by-autocomplete{
  //     border-bottom-left-radius: 0;
  //   border-bottom-right-radius: 0;
  // }

  .input-container {
    // border-bottom: 1px solid white;
    // box-sizing: border-box;
          border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    
    
  }

  



  .input__prefix {
    border-bottom: 1px solid white;

  }
  .by-input__inner {
    border-bottom: 1px solid white;
    &:focus {
      border-radius: 0px !important;
      border-color: #fff !important;
    }
  }
  .by-autocomplete-suggestion {
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
 
    overflow: hidden;
    position: absolute;
    width: 100%;
    z-index: 1;
    left: 0;
    .flex{
      width: 100%;
      display: flex;
    }
    .el-scrollbar{
      width: 100%;
      /deep/ .el-scrollbar__wrap{
        overflow-x: hidden;
      }
    }
    
  }
}

.is_error .pickup__error.input-container{
  border: 1px solid rgba(red,.5);
}
</style>


// WEBPACK FOOTER //
// src/components/reception/checkPrice/components/ByAutocomplete.vue